(function () {
    var productList = document.getElementById('WholesaleProductList');
    var fromLine = document.getElementById('WholesaleFromLine');
    if (!productList || !fromLine) return;
  
    var checkList = productList.querySelectorAll('.product-check');
    var selected = [];
  
    function syncInput() {
      fromLine.value = selected.join(', ');
    }
  
    function setOpen(open) {
      productList.hidden = !open;
      productList.style.display = open ? 'block' : 'none';
      fromLine.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  
    fromLine.addEventListener('click', function () {
      setOpen(productList.hidden || productList.style.display === 'none');
    });
  
    document.addEventListener('click', function (event) {
      if (!fromLine.contains(event.target) && !productList.contains(event.target)) {
        setOpen(false);
      }
    });
  
    checkList.forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        var value = checkbox.value;
        var index = selected.indexOf(value);
  
        if (checkbox.checked && index === -1) {
          selected.push(value);
        } else if (!checkbox.checked && index !== -1) {
          selected.splice(index, 1);
        }
  
        syncInput();
      });
    });
  })();
  